'use client';

import React, { useRef, useState } from 'react';
import isEqual from 'react-fast-compare';
import { createGlobalStyle } from 'styled-components';
import type { ThemeContext } from '../types';

const GlobalIgnoreTransitionsStyle = createGlobalStyle`
    * {
        -webkit-transition: none !important;
        -moz-transition: none !important;
        -o-transition: none !important;
        -ms-transition: none !important;
        transition: none !important;
      }
`;

/**
 * Determines whether or not the theme is actively transitioning and injects global styles that block CSS transitions.
 * On the next tick, it will remove the global styles.
 * @returns GlobalStyledComponent
 */

export const useThemeTransition = ({ context }: { context: ThemeContext }) => {
  const [pauseTransitions, setPauseTransitions] = useState(false);

  const prevContextRef = useRef(context);

  if (!isEqual(prevContextRef.current, context)) {
    setPauseTransitions(true);
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        setPauseTransitions(false);
      });
    });
    prevContextRef.current = context;
  }

  return pauseTransitions ? <GlobalIgnoreTransitionsStyle /> : null;
};
